import React, { useEffect, useState } from 'react';
import {
  Dropdown,
  DropdownButton,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { useTranslation } from '../../../translations';
import { GetEmailAddressDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { DragNDropFile } from '../../../common/components/File/DragNDropFiles';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { AttachmentObjectType } from '../../../common/pokCore/validation/enums';

import { EmailResendForm } from './EmailResendForm';

export const EmailResendLink = (props: {
  invoiceIds: string[];
  emailId: string;
  refreshData: () => void;
  emailAddresses: GetEmailAddressDto | undefined;
}) => {
  const { t, tk } = useTranslation('fvsLng');

  const [showModal, setShowModal] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [myAttachments, setMyAttachments] = useState<DragNDropFile[]>([]);
  const pok = usePokCore();
  const notifications = useNotifications();

  const resend = (duplicateFvs: boolean) => {
    setShowModal(true);
    setDuplicate(duplicateFvs);
  };

  useEffect(() => {
    if (showModal) {
      pok.attachments
        .getAttachmentsInfoWithSizeForObjects(
          props.invoiceIds,
          AttachmentObjectType.SalesInvoice,
        )
        .then(attachments => {
          const myFiles: DragNDropFile[] = attachments.map(attachment => {
            return {
              id: attachment.id,
              name: attachment.name || '',
              size: attachment.fileSize || 0,
            };
          });
          setMyAttachments(myFiles);
        })
        .catch(err => {
          notifications.caughtError(err);
        });
    }
  }, [notifications, pok.attachments, props.invoiceIds, showModal]);

  return (
    <>
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>
            {t(tk.sendEmail.sendAgain)}
          </Tooltip>
        }
      >
        <DropdownButton
          title={<Icon.ArrowClockwise size={16} />}
          id="clone-dropdown"
          variant="outline-primary"
          className="py-2 ps-1"
        >
          <Dropdown.Item onClick={() => resend(false)} eventKey="1">
            {t(tk.sendEmail.sendAgainFVS)}
          </Dropdown.Item>
          <Dropdown.Item onClick={() => resend(true)} eventKey="1">
            {t(tk.sendEmail.sendAgainFVSDuplicate)}
          </Dropdown.Item>
        </DropdownButton>
      </OverlayTrigger>
      {showModal && (
        <EmailResendForm
          invoiceIds={props.invoiceIds}
          emailId={props.emailId}
          emailAddresses={props.emailAddresses}
          show={showModal}
          duplicate={duplicate}
          refreshData={props.refreshData}
          existingFiles={myAttachments}
          onClose={() => {
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};
